import axios from 'axios'
import moment from 'moment'
import {typesShipCli} from '../svtypes/cliTypes'
import {SVCR_PROMO_RQ,SVCR_HOME_RQ, SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_SVDJMOCK_ADDRESS, SV_SOJ_SVDJMOCK_BRIDGE, CARN_URL,IM_SOURCE_TYPE,IM_AWS,IM_SVAMCOS,COSMOS_IM_URL ,IM_PSURLS_AWS} from '../../constants';
const _ = require('lodash')
/*
import {
    browserHistory as history
  } from 'react-router'

*/

const headers = {'Content-Type': 'application/json'}

function shuffle(array) {  for (let i = array.length - 1; i > 0; i--) {    const j = Math.floor(Math.random() * (i + 1));    [array[i], array[j]] = [array[j], array[i]];  }}


function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }
//svsept26 start




export const getCruiseSearchSuccess = (data) => dispatch => {
    dispatch({
        type: typesShipCli.GET_SHIP_CLI_SUCCESS,
        payload: data
    })
}

export const getFlySearchServerError = (data) => dispatch => {
    let eob = {
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "FlyServer Error",
        "message": "No Resulst Found.Please refinse search and try again",
        "path": "/kk/svaddressDetailPost"
    }
    dispatch({
        type:typesShipCli.GET_SHIP_CLI_ERROR,
        error:eob
    })
}

export const getCruiseSearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: "GET_SHIP_CLI_SUCCESS",
        payload: data
    })
}

export const getCruiseSearchBegin = () => dispatch => {
    dispatch({
        type:typesShipCli.GET_SHIP_CLI_BEGIN
        
    })
}

export const getCruiseSearchError = (e) =>dispatch => {
    dispatch({
        type:typesShipCli.GET_SHIP_CLI_ERROR,
        error:e
    })
}


export const getFindCliEsQueryDataSuccess = (data) => dispatch => {
   
    dispatch({
       type: "SVFINDFILTERS_CLI_SUCCESS",
       payload: data
   })

  
}

export const saveFindCliEsQueryDataSuccess = (data) => dispatch => {
    console.log('sv*********saveFindCliEsQueryDataSuccess  start')
    console.log(data)
    console.log('sv*********saveFindCliEsQueryDataSuccess  end')
   
     
     let new_esquery_data = { svcli_esquery_data : data.svcli_esquery_data}
     dispatch(getFindCliEsQueryDataSuccess(new_esquery_data))
}



export function cliAndImagesSV_bakSVJun7Y25Good(sojPostRqFromPage,  svcli_esquery_data){
    /* SV TODO this Code */
    console.log("sv NOV!5*** cliAndImagesSV ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruiseSearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        //let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcEx`
       

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
      
        const urlPresignedFromServer = `${SV_SOJ_ORCMOCK_ADDRESS}/api/image/123`
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
            /*
            if(_.isObject(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage
                
            }else if(_.isString(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage == 'svpromo' ? SVCR_PROMO_RQ : SVCR_HOME_RQ
                urlSoj = sojPostRqFromPage == 'svpromo' ? `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExPROMO` :`${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExPROMO`
               
            }
             */
            
           
  
            /*svaug29 end*/
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
           
           
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {svo} = rFobMerge
                console.log('86 sending svo ',svo)
                const comData = { my_data: [], my_data_geo:{}}
                /*
"path" :"00/Q_QV/1a_hb_ex_004.jpg"
                */
                /*svdec21  start*/
                for(let m=0; m< svo.length; m++){
                    let imgs = [],carn_images = null
                   carn_images = svo[m].images
                   if(carn_images && (carn_images.length > 0) ){
                    carn_images.forEach(im =>{
                        /*svjun1 start*/

                        let sim =''
                        if(IM_SOURCE_TYPE == IM_AWS){
                            let s= im.path 
                            let m  = s.replace('00/', '')
                            sim =  COSMOS_IM_URL +  m 
                            console.log('presigned url :',sim)
                           

                        }else{

                             sim =  CARN_URL +  im.path 
                             console.log('svmay29*******86',sim)
                        }

                         /*svjun1 end*/
                        
                        imgs.push(sim)
                       })
                    }else{
                        imgs = r2.data.images
                    }
                    svo[m].imgs = imgs
                }
                /*svdec21  end*/
                if(svo && (svo.length > 0) ){


                    comData.my_data = svo


                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                comData.my_scr_id = rFobMerge.my_scr_id
                dispatch(getCruiseSearchMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruiseSearchError(e))}
           
        )
    }
}

/*svaug26 end */

/*sjmar7 start*/

export function cliAndImagesSojournMore(sojPostRqFromPage,  svcli_esquery_data){
    /* SV TODO this Code */
    console.log("sv NOV!5*** cliAndImagesSojournMore ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruiseSearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        //let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExMore`
       

          let sojPostRq = {
           
            "my_scr_id":"FGluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR"
        }
      
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            if(_.isObject(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage
            }else if(_.isString(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage == 'svpromo' ? SVCR_PROMO_RQ : SVCR_HOME_RQ
                urlSoj = sojPostRqFromPage == 'svpromo' ? `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExMore` :`${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExPROMO`

            }
            
           
  
            /*svaug29 end*/
        }

        
/*
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       */
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
           
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {svo} = rFobMerge
                console.log('86 sending svo ',svo)
                const comData = { my_data: [], my_data_geo:{}}
                /*svdec21  start*/
                for(let m=0; m< svo.length; m++){
                    let imgs = [],carn_images = null
                   carn_images = svo[m].images
                   if(carn_images && (carn_images.length > 0) ){
                    carn_images.forEach(im =>{
                        let sim =  CARN_URL +  im.path 
                        imgs.push(sim)
                       })
                    }else{
                        imgs = r2.data.images
                    }
                    svo[m].imgs = imgs
                }
                /*svdec21  end*/
                if(svo && (svo.length > 0) ){


                    comData.my_data = svo


                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                comData.my_scr_id = rFobMerge.my_scr_id
                dispatch(getCruiseSearchMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruiseSearchError(e))}
           
        )
    }
}
/*sjmar7 end */
/*svmar14 start */
export function cliCountryCodeSV(sojPostRqFromPage,  svfly_esquery_data){
    console.log("sv NOV!5*** flyAndImagesSV ******sv_esquery_data********", svfly_esquery_data)
   
    
    return dispatch => {
        dispatch(getMetaSearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
       
      
          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
        
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcCliMetaData`
        const bodyGeoList = {"docId":["5"],"hsetname":"CARNIVAL"}
       
        axios.all([
          //  axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
            axios.post(urlGeoList, bodyGeoList, {headers:headers}),
        ])
        .then(
            //axios.spread((rFobAx,r2,r5)=>{
            axios.spread((r2,r5)=>{
               // let rFob = rFobAx.data
              
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(r5)
                console.log('sv**OCT23 WED **************** r  END')
                if(r5.data.svcli_meta_data.port.length>0){
                   
                    const comData = { my_data_geo:{}}
                     //svr5 start
                     let my_data_meta= null
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.svcli_meta_data  && r5.data.svcli_meta_data.port && r5.data.svcli_meta_data.port.length>0){
                        /*svmar17 FIX TOTDO DEPLOY **/
                      my_data_meta= r5.data.svcli_meta_data 
                      /*svmar17 FIX TOTDO DEPLOY END **/
                      comData.my_data_meta= my_data_meta
                     }
                     console.log(comData )
                     //svr5 end

                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                   
                    console.log('sv**may14 sv my_data_meta GOTa*********')
                    
                   
                   
                    dispatch(getMetaSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = {  my_data_meta:{}}
                     //svr5 start
                    
                    dispatch(getMetaSearchServerError(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getMetaSearchError(e))}
           
        )
    }
}

export const getMetaSearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: "GET_META_FLY_SUCCESS",
        payload: data
    })
}

export const getMetaSearchBegin = () => dispatch => {
    dispatch({
        type:typesShipCli.GET_META_FLY_BEGIN
        
    })
}

export const getMetaSearchError = (e) =>dispatch => {
    dispatch({
        type:typesShipCli.GET_META_FLY_ERROR,
        error:e
    })
}

export const getMetaSearchServerError = (data) => dispatch => {
    let eob = {
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "MetaServer Error",
        "message": "No  Meta Resulst Found.Please contact Admin",
        "path": "/kk/svaddressDetailPost"
    }
    dispatch({
        type:typesShipCli.GET_META_FLY_ERROR,
        error:eob
    })
}
/*svmar14 end*/

/*svjun7 start*/


/*
export function cliAndImagesSV_cdevtest(sojPostRqFromPage,  svcli_esquery_data){
   
    console.log("sv NOV!5*** cliAndImagesSV ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruiseSearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        //let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcEx`
       

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
      
        const urlPresignedFromServer = `${SV_SOJ_ORCMOCK_ADDRESS}/api/image/123`
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
           
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers}),
            axios.get(urlPresignedFromServer, {headers:headers}),
           
        ])
        .then(
            axios.spread((rFobAx,r2, r3)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {svo} = rFobMerge
                console.log('86 sending svo ',svo)
                const comData = { my_data: [], my_data_geo:{}}
               
                for(let m=0; m< svo.length; m++){
                    let imgs = [],carn_images = null
                   carn_images = svo[m].images
                   if(carn_images && (carn_images.length > 0) ){
                    carn_images.forEach(im =>{
                      

                        let sim =''
                        if(IM_SOURCE_TYPE == IM_AWS){
                            let s= im.path 
                            let m  = s.replace('00/', '')
                            sim =  COSMOS_IM_URL +  m 
                            console.log('presigned url :',sim)
                            sim = r3.data.url
                            console.log('svmay29*******S3', sim)

                        }else{

                             sim =  CARN_URL +  im.path 
                             console.log('svmay29*******86',sim)
                        }

                      
                        
                        imgs.push(sim)
                       })
                    }else{
                        imgs = r2.data.images
                    }
                    svo[m].imgs = imgs
                }
               
                if(svo && (svo.length > 0) ){


                    comData.my_data = svo


                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                comData.my_scr_id = rFobMerge.my_scr_id
                dispatch(getCruiseSearchMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruiseSearchError(e))}
           
        )
    }
}
*/
/*svjun7 end*/
/***NNNNNNNNMMMMMMMMODODMOD MOD MDOD */

export function cliAndImagesSV(sojPostRqFromPage,  svcli_esquery_data){
    /* SV TODO this Code */
    console.log("sv NOV!5*** cliAndImagesSV ******sv_esquery_data********", svcli_esquery_data)
   
    
    return dispatch => {
        dispatch(getCruiseSearchBegin())
       //localhost:8000/amcosmosbika/ttsvfacetttr
       ///clipoint/svcruiseCanQueryFinalDyna
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlBridge = null
        //let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/clipoint/svcruiseCanQueryFinalDyna`
        let urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcEx`
        if(IM_SOURCE_TYPE == IM_AWS){
            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcEx`
           
        }else if(IM_SOURCE_TYPE == IM_PSURLS_AWS){
            
            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExPS`

        }else{

            urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcEx`
        }

       

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
             "org": "09A",
            "dst":"ADQ"
        }
      
        const urlPresignedFromServer = `${SV_SOJ_ORCMOCK_ADDRESS}/api/image/123`
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
            /*
            if(_.isObject(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage
                
            }else if(_.isString(sojPostRqFromPage)){
                sojPostRq = sojPostRqFromPage == 'svpromo' ? SVCR_PROMO_RQ : SVCR_HOME_RQ
                urlSoj = sojPostRqFromPage == 'svpromo' ? `${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExPROMO` :`${SV_SOJ_ORCMOCK_ADDRESS}/account/svcExPROMO`
               
            }
             */
            
           
  
            /*svaug29 end*/
        }

        

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geography`
        const bodyGeoList = {"docId":["USA"],"hsetname":"HotelInvDB"}
       
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
           
           
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
           
              
               //let rFob = rFobMerge.svflighs
               
              
               
               
                
               
                console.log('sv**OCT23 WED ****************  amb flighyr START')
                console.log(rFobAx)
                console.log(r2)
                console.log('sv**OCT23 WED **************** r  END')
                let rFobMerge = rFobAx.data
                const {svo} = rFobMerge
                console.log('86 sending svo ',svo)
                const comData = { my_data: [], my_data_geo:{}}
                /*
"path" :"00/Q_QV/1a_hb_ex_004.jpg"
                */
                /*svdec21  start*/
                for(let m=0; m< svo.length; m++){
                    let imgs = [],carn_images = null
                   carn_images = svo[m].images
                   if(carn_images && (carn_images.length > 0) ){
                    carn_images.forEach(im =>{
                        /*svjun1 start*/

                        let sim =''
                        if(IM_SOURCE_TYPE == IM_AWS){
                            let s= im.path 
                            let m  = s.replace('00/', '')
                            sim =  COSMOS_IM_URL +  m 
                            console.log('presigned url :',sim)
                           
                        }else if(IM_SOURCE_TYPE == IM_PSURLS_AWS){
                            
                            sim = im.psurls
                            console.log('svmay29*******S3', sim)

                        }else{

                             sim =  CARN_URL +  im.path 
                             console.log('svmay29*******86',sim)
                        }

                         /*svjun1 end*/
                        
                        imgs.push(sim)
                       })

                    }else{
                        imgs = r2.data.images
                    }
                    shuffle(imgs)
                    svo[m].imgs = imgs
                }
                /*svdec21  end*/
                if(svo && (svo.length > 0) ){


                    comData.my_data = svo


                }else{
                    console.log('86 sending svo null')
                        
                
                }
                comData.svcli_esquery_data =  svcli_esquery_data 
                comData.my_scr_id = rFobMerge.my_scr_id
                dispatch(getCruiseSearchMultiplceCallsSuccess(comData))

             
                   
                }
            )
        ).catch(
            e=>{dispatch(getCruiseSearchError(e))}
           
        )
    }
}